<script setup lang="ts">
import { resetEverything } from '@/utils/reset'
import { useRouter } from 'vue-router'

defineProps({
  mini: {
    type: Boolean,
    default: false
  }
})

const router = useRouter()

async function onReset() {
  await resetEverything()
  router.push('/agreement/vehicle')
}
</script>

<template>
  <v-btn
    v-if="mini"
    icon="mdi-restart"
    variant="text"
    size="small"
    @click="onReset"
  />
  <v-btn
    v-else
    prepend-icon="mdi-restart"
    text="Nulstil"
    :block="$vuetify.display.mobile"
    @click="onReset"
  />
</template>